import { Box, Container } from '@mui/system'
import { Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import ExpiredLinkImage from '../../images/AccessDenied.svg'
import ResponsiveAppBar from '../../components/ResponsiveAppBar/index.jsx'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn'
import AppRoutes from '../../services/AppRoutes'
import UseTranslation from '../../hooks/UseTranslation.jsx'

const ExpiredLink = () => {
  const history = useHistory()
  const { t } = UseTranslation()
  const redirectToLoginPage = () => {
    history.push(AppRoutes.login);
  }
  return (
     <Box sx={styles.root}>
      <ResponsiveAppBar onlyLogo notLogin />
      <Container maxWidth="xl" sx={styles.container}>
        <Box sx={styles.textWrapper}>
          <Typography sx={styles.expireTitle} variant="h1">
            {t?.['Expired Link !']}
          </Typography>
          <Typography variant="h3" sx={styles.expireSubTitle}>
            {t?.['Sorry but the link you are trying to reach is expired.']}
          </Typography>
          <Typography variant="p" sx={styles.expireDescription}>
            {t?.['The password reset link has expired. Please make a new request to reset your password where a new link will be sent to your mail.']}
          </Typography>
          <OfoqThemeBtn
            name={t?.['Move to Login']}
            onClick={redirectToLoginPage}
            customStyle={styles.requestBtn}
          />
        </Box>
        <Box component="img" src={ExpiredLinkImage} sx={styles.image} />
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    paddingTop: '-20px',
  },
  container: {
    display: 'flex',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    justifyContent: { xs: 'center', md: 'space-between' },
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '650px',
    width: '100%',
    alignItems: { xs: 'center', md: 'flex-start' },
    padding: { xs: '20px 0 0 0px', md: '150px 0 0 80px' },
  },
  expireTitle: {
    color: 'primary.main',
    fontSize: { xs: '20px', sm: '30px', md: '50px' },
    lineHeight: '19px',
  },
  expireSubTitle: {
    fontSize: { xs: '14px', sm: '18px', md: '22px' },
    lineHeight: '25px',
    paddingTop: { xs: '20px', md: '70px' },
  },
  expireDescription: {
    fontSize: { xs: '12px', sm: '16px', md: '18px' },
    lineHeight: { xs: '20px', md: '43px' },
    paddingTop: { xs: '10px', md: '30px' },
    color: '#92929D',
    textAlign: { xs: 'center', sm: 'left' },
  },
  image: {
    position: 'relative',
    zIndex: -5,
    my: { xs: '10px', md: 'unset' },
    width: { xs: '100%', sm: '300px', md: '400px', lg: '600px' },
    height: { xs: '250px', sm: '100%', md: '400px', lg: '600px' },
    '& img': {
      mt: '20px',
    },
  },
  requestBtn: {
    maxWidth: { xs: '100%', sm: '250px' },
    height: '40px',
    mt: '20px',
  },
}

export default ExpiredLink
